// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Alert_hidden__2G0y0","visible":"Alert_visible__JUXyZ","title":"Alert_title__25eVU","button":"Alert_button__1gBHa"};